(() => {
  const pad = (value) => String(value).padStart(2, '0');
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const setCountdownValue = (element, value, animate) => {
    const current = element.querySelector('.up-countdown-value');
    if (!current || current.textContent === value) return;

    if (!animate || reduceMotion) {
      current.textContent = value;
      return;
    }

    const next = document.createElement('span');
    next.className = 'up-countdown-value up-countdown-value--next';
    next.textContent = value;
    element.append(next);

    requestAnimationFrame(() => {
      requestAnimationFrame(() => element.classList.add('is-sliding'));
    });

    window.setTimeout(() => {
      current.remove();
      next.classList.remove('up-countdown-value--next');
      element.classList.remove('is-sliding');
    }, 420);
  };

  const zonedDateToTimestamp = (parts, timeZone) => {
    const targetAsUtc = Date.UTC(parts.year, parts.month - 1, parts.day, parts.hour, parts.minute);
    const formatter = new Intl.DateTimeFormat('en-CA', {
      timeZone,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hourCycle: 'h23'
    });

    const getOffset = (timestamp) => {
      const zonedParts = Object.fromEntries(
        formatter.formatToParts(new Date(timestamp))
          .filter((part) => part.type !== 'literal')
          .map((part) => [part.type, Number(part.value)])
      );

      const displayedAsUtc = Date.UTC(
        zonedParts.year,
        zonedParts.month - 1,
        zonedParts.day,
        zonedParts.hour,
        zonedParts.minute,
        zonedParts.second
      );

      return displayedAsUtc - timestamp;
    };

    let timestamp = targetAsUtc - getOffset(targetAsUtc);
    timestamp = targetAsUtc - getOffset(timestamp);
    return timestamp;
  };

  const updateHeight = (section) => {
    document.documentElement.style.setProperty(
      '--announcement-bar-height',
      `${Math.round(section.getBoundingClientRect().height)}px`
    );
  };

  const startCampaign = (campaign) => {
    if (campaign.dataset.upCountdownReady === 'true') return;

    const countdown = campaign.querySelector('[data-up-countdown]');
    const dateParts = {
      year: Number(campaign.dataset.endYear),
      month: Number(campaign.dataset.endMonth),
      day: Number(campaign.dataset.endDay),
      hour: Number(campaign.dataset.endHour),
      minute: Number(campaign.dataset.endMinute)
    };
    const endTime = zonedDateToTimestamp(dateParts, campaign.dataset.timeZone || 'Europe/Stockholm');
    if (!countdown || Number.isNaN(endTime)) return;

    campaign.dataset.upCountdownReady = 'true';

    let firstRender = true;

    const render = () => {
      const remaining = Math.max(0, endTime - Date.now());
      const totalSeconds = Math.floor(remaining / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      setCountdownValue(campaign.querySelector('[data-days]'), pad(days), !firstRender);
      setCountdownValue(campaign.querySelector('[data-hours]'), pad(hours), !firstRender);
      setCountdownValue(campaign.querySelector('[data-minutes]'), pad(minutes), !firstRender);
      setCountdownValue(campaign.querySelector('[data-seconds]'), pad(seconds), !firstRender);
      firstRender = false;

      if (remaining > 0) return;

      window.clearInterval(interval);
      const action = campaign.dataset.expiredAction;

      if (action === 'hide_campaign') {
        campaign.hidden = true;
      } else {
        countdown.hidden = true;
        if (action === 'message') {
          campaign.querySelector('[data-up-expired]')?.removeAttribute('hidden');
        }
      }

      const section = campaign.closest('.shopify-section');
      if (section) updateHeight(section);
    };

    const interval = window.setInterval(render, 1000);
    render();
  };

  const init = (root = document) => {
    root.querySelectorAll('[data-up-campaign]').forEach(startCampaign);
  };

  document.addEventListener('DOMContentLoaded', () => init());
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('shopify:block:select', (event) => init(event.target));
})();
